import { Text, TextButton } from '@wix/design-system';
import { ModalsModule } from '@wix/domains-search-suite';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { SearchedDomainBrokerDataHooks } from './dataHooks';
import { useHireBroker } from './useHireBroker';
export const BrokerDescription = _ref => {
  let domainName = _ref.domainName;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    Trans = _DomainSearchGateModu.Trans;
  const brokerServiceModal = ModalsModule.internals.domainsSharedModalsController.brokerServiceModal;
  const hireBroker = useHireBroker(domainName);
  return /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_gate.results.searched_domain.status.broker.description",
    components: [/*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "thin",
      skin: "dark",
      underline: "always",
      dataHook: SearchedDomainBrokerDataHooks.howItWorks,
      onClick: () => brokerServiceModal.show({
        domainName,
        onConfirm: () => {
          brokerServiceModal.hide();
          hireBroker();
        }
      })
    })]
  }));
};
//# sourceMappingURL=BrokerDescription.js.map